// extracted by mini-css-extract-plugin
module.exports = {"container":"_9330de7794--container--wuxos","content":"_9330de7794--content--Snlaf","disclaimer":"_9330de7794--disclaimer--mhSfa","menu":"_9330de7794--menu--_ZmyP"};